import React from "react";
import Link from 'next/link';

const ProducersPanel = (props: { 
  article: any, 
  producers: any, 
  relatedArticles: any, 
  producersPanelOpen: boolean, 
  toggleProducersPanel: Function,
  className?: string
}) => {
  const { article, producers, relatedArticles, producersPanelOpen, toggleProducersPanel, className } = props;
  const relatedArticleYears = relatedArticles && Object.keys(relatedArticles).reverse() || [];

  const producersTransform = `transition-all transform ${producersPanelOpen ? "-translate-x-full" : "translate-x-0"} lg:translate-x-0`
  const showWinesAndProducers = producers && producers.length > 0;

  return (
    <>
      <div className={`${producersTransform} fixed z-50 p-4 space-y-4 left-full top-0 h-full bg-gray-100 lg:relative lg:z-0 lg:left-0 lg:bg-transparent w-4/5 min-w-4/5 flex-grow-2 lg:space-y-8 ${className}`} style={{minWidth: "20%"}}>
        <div className={`transition-all bg-red text-white rounded-md rounded-r-none h-12 w-12 flex justify-center items-center cursor-pointer lg:hidden absolute -left-12 bottom-12 shadow-lg`} 
          onClick={() => { toggleProducersPanel() }}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === "Enter") { toggleProducersPanel() }}} 
        >
          <svg className={`transition-all transform ${producersPanelOpen ? "-rotate-90" : "rotate-90"}`} xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
        {showWinesAndProducers && 
          <>
            <h2 className="text-center font-normal text-red cursor-pointer left-30">
              <Link href={`/articles/${article?.slug}/reviews?order=desc&orderType=score`}>Show all the wines (sorted by score)</Link>
            </h2>
          </>
        }
        {showWinesAndProducers && 
          <>
            <h2 className="text-xl w-full text-center">Producers in this Article</h2>
            <div className={`lg:flex-column lg:items-start lg:space-y-1 overflow-y-auto relative`} style={{maxHeight: "600px"}}>
              <ul>
                {producers && producers.map((producer) => {
                  return (
                    <li className="pb-1 font-normal text-red cursor-pointer" key={producer.id}>
                      <Link href={`/producers/${producer.slug}?article_id=${article.id}`}>{producer.producer_name}</Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </>
        }
        {relatedArticles && Object.keys(relatedArticles).length > 0 && 
          <>
            <h2 className="text-xl w-full text-center">Related Articles</h2>
            <div className={`h-px-300 lg:flex-column lg:items-start lg:space-y-1 overflow-y-auto relative`} style={{maxHeight: "300px"}}>
              {relatedArticles && relatedArticleYears.map((year) => {
                return (
                  <div className="border-b mb-2" key={year}>
                    <p className="font-normal text-center w-full">{year}</p>
                    <ul key={`${year}-articles`}>
                      {relatedArticles[year].map((a) => {
                        return (
                          <li className="pb-3 font-normal text-red cursor-pointer" key={a.id}>
                            <Link href={`/articles/${a.slug}`}>{a.title}</Link>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                )
              })}
            </div>
          </>
        }
      </div>
    </>
  )
}

export default ProducersPanel;